module.exports = __webpack_public_path__ + "img/information.38330ec5.svg";